/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';

/**
 * 
 * @export
 * @interface EvaluationSeriesAttributeDTO
 */
export interface EvaluationSeriesAttributeDTO {
    /**
     * 
     * @type {string}
     * @memberof EvaluationSeriesAttributeDTO
     */
    attributeName: string;
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof EvaluationSeriesAttributeDTO
     */
    attributeType: AttributeTypeDTO;
    /**
     * 
     * @type {string}
     * @memberof EvaluationSeriesAttributeDTO
     */
    evaluationSeriesId: string;
}



/**
 * Check if a given object implements the EvaluationSeriesAttributeDTO interface.
 */
export function instanceOfEvaluationSeriesAttributeDTO(value: object): value is EvaluationSeriesAttributeDTO {
    if (!('attributeName' in value) || value['attributeName'] === undefined) return false;
    if (!('attributeType' in value) || value['attributeType'] === undefined) return false;
    if (!('evaluationSeriesId' in value) || value['evaluationSeriesId'] === undefined) return false;
    return true;
}

export function EvaluationSeriesAttributeDTOFromJSON(json: any): EvaluationSeriesAttributeDTO {
    return EvaluationSeriesAttributeDTOFromJSONTyped(json, false);
}

export function EvaluationSeriesAttributeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationSeriesAttributeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeName': json['attributeName'],
        'attributeType': AttributeTypeDTOFromJSON(json['attributeType']),
        'evaluationSeriesId': json['evaluationSeriesId'],
    };
}

export function EvaluationSeriesAttributeDTOToJSON(value?: EvaluationSeriesAttributeDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeName': value['attributeName'],
        'attributeType': AttributeTypeDTOToJSON(value['attributeType']),
        'evaluationSeriesId': value['evaluationSeriesId'],
    };
}

